var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "680",
      dialog: _vm.show,
      maxWidth: "680",
      title: _vm.title,
    },
    on: { close: _vm.closeMappingDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_shift_form_dialog_eventTypeLabel",
                            items: _vm.EventType,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "item-text": "event_type_name",
                            "item-value": "uuid",
                          },
                          model: {
                            value: _vm.curType,
                            callback: function ($$v) {
                              _vm.curType = $$v
                            },
                            expression: "curType",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_shift_form_dialog_eventNameLabel",
                            items: _vm.activeEventList,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "item-text": "event_business_name",
                            "item-value": "uuid",
                          },
                          model: {
                            value: _vm.curEvent,
                            callback: function ($$v) {
                              _vm.curEvent = $$v
                            },
                            expression: "curEvent",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.curEventObject != null
                      ? _c(
                          "v-col",
                          {
                            staticClass: "mt-n5",
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass: "pa-6",
                                attrs: {
                                  width: "100%",
                                  elevation: "0",
                                  color: "grey lighten-4",
                                },
                              },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pt-0 pb-0",
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "text--secondary pl-1 transparent",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_shift_form_dialog_eventDescriptionLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t(
                                              "label_essweb_shift_form_dialog_eventDescriptionLabel"
                                            ),
                                            "single-line": "",
                                            value: _vm.$getCommonLangValue(
                                              _vm.curEventObject
                                                .event_business_description
                                            ),
                                            filled: "",
                                            disabled: true,
                                            dense: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pt-0 pb-0",
                                        attrs: {
                                          xs: "12",
                                          sm: "6",
                                          md: "6",
                                          lg: "6",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "text--secondary pl-1 transparent",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_shift_form_dialog_startTimeLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t(
                                              "label_essweb_shift_form_dialog_startTimeLabel"
                                            ),
                                            "single-line": "",
                                            filled: "",
                                            disabled: true,
                                            value: _vm.$timeMachine(
                                              _vm.curEventObject.start_utc_time
                                            ),
                                            dense: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pt-0 pb-0",
                                        attrs: {
                                          xs: "12",
                                          sm: "6",
                                          md: "6",
                                          lg: "6",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "transparent text--secondary",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_shift_form_dialog_startTimeZoneLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.staticZone,
                                            "single-line": "",
                                            dense: "",
                                            "append-icon": "",
                                            "menu-props": {
                                              offsetY: true,
                                              transition: "slide-y-transition",
                                              rounded: true,
                                              contentClass: "elevation-4",
                                            },
                                            disabled: true,
                                            "item-text": "text",
                                            "item-value": "utc",
                                            filled: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            3871233564
                                          ),
                                          model: {
                                            value:
                                              _vm.curEventObject
                                                .start_time_time_zone,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.curEventObject,
                                                "start_time_time_zone",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "curEventObject.start_time_time_zone",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pt-0 pb-0",
                                        attrs: {
                                          xs: "12",
                                          sm: "6",
                                          md: "6",
                                          lg: "6",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "transparent text--secondary",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_shift_form_dialog_endTimeLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t(
                                              "label_essweb_shift_form_dialog_endTimeLabel"
                                            ),
                                            "single-line": "",
                                            value: _vm.$timeMachine(
                                              _vm.curEventObject.end_utc_time
                                            ),
                                            filled: "",
                                            disabled: true,
                                            dense: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pt-0 pb-0",
                                        attrs: {
                                          xs: "12",
                                          sm: "6",
                                          md: "6",
                                          lg: "6",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "transparent text--secondary",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_shift_form_dialog_endTimeZoneLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.staticZone,
                                            "single-line": "",
                                            dense: "",
                                            "append-icon": "",
                                            "menu-props": {
                                              offsetY: true,
                                              transition: "slide-y-transition",
                                              rounded: true,
                                              contentClass: "elevation-4",
                                            },
                                            disabled: true,
                                            "item-text": "text",
                                            "item-value": "utc",
                                            filled: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            3871233564
                                          ),
                                          model: {
                                            value:
                                              _vm.curEventObject
                                                .end_time_time_zone,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.curEventObject,
                                                "end_time_time_zone",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "curEventObject.end_time_time_zone",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pt-0 pb-0",
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "transparent text--secondary",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_shift_form_dialog_totalMinuteLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t(
                                              "label_essweb_shift_form_dialog_totalMinuteLabel"
                                            ),
                                            "single-line": "",
                                            value:
                                              Number(
                                                _vm.curEventObject.end_utc_time
                                              ) -
                                              Number(
                                                _vm.curEventObject
                                                  .start_utc_time
                                              ),
                                            filled: "",
                                            disabled: true,
                                            dense: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn: _vm.action == "new",
                saveBtn: _vm.action == "edit",
              },
              on: {
                new: _vm.newMapping,
                save: _vm.editMapping,
                cancel: _vm.closeMappingDialog,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }